module.exports = __webpack_public_path__ + "img/hero-bgg.9f3b3530.png";